import { toInteger } from "lodash";
import React from "react";
import {
  Column,
  KeyHolder,
  KeyIcon,
  MainTitle,
  SubText,
} from "../Restricted.styled";

const restrictedStrings = {
  mainTitle: "Você se interessou por essa matéria?",
  subTitle: "Você atingiu o limite de matérias exclusivas por mês.",
};

type RestrictedType = {
  trialSize: number;
};

type keysArrayType = {
  used: boolean;
};

const RestrictedExpiredPaywall: React.FC<
  RestrictedType & { bannerData: any }
> = ({ bannerData }) => {
  const trialSize = bannerData.chavesAcesso;
  const trialSizeString = `Você atingiu o limite de <strong>${bannerData.chavesAcesso?.toString()} matérias</strong> exclusivas por mês.`;
  const keysArray: keysArrayType[] = [];
  for (let i = 0; i < trialSize; i++) {
    keysArray.push({ used: false });
  }
  return (
    <>
     {bannerData && bannerData.chavesAcesso > 0 &&
     <>
      <MainTitle customCss={{ mb: "$2" }}>
        {restrictedStrings.mainTitle}
      </MainTitle>
      <Column
        customCss={{
          maxWidth: "auto",
          "@lg": { width: "100%" },
        }}
      >
        <SubText
          customCss={{
            fontSize: "18px",
            lineHeight: "23px",
            letterSpacing: "0.2px",
            fontWeight: 400,
            "@lg": { minHeight: "auto" },
          }}
        >
          {bannerData ? trialSizeString : restrictedStrings.subTitle}
        </SubText>
        <KeyHolder>
          {keysArray.map((item, key) => {
            return <KeyIcon key={key} used={item.used}></KeyIcon>;
          })}
        </KeyHolder>
      </Column>
      </>
}
    </>
  );
};

export default RestrictedExpiredPaywall;
